import "./polyfills.js";
import "./robots.txt";

import React from "react";
import ReactDom from "react-dom";
import { Provider } from "react-redux";
import configureStore from "./store/configureStore";
import "normalize.css";
import "./styles/main.scss";
import App from "./components/App";
import { setAuthToken } from "./actions/authDrawer";
import { getUserData } from "./actions/user";
import { getLocalItem } from "./utils/localdb";

if (typeof window !== "undefined") {
  const preloadedState = window.__PRELOADED_STATE__;
  delete window.__PRELOADED_STATE__;

  const store = configureStore(preloadedState);

  const token = getLocalItem("authToken");
  if (token) {
    store.dispatch(setAuthToken(token))
      .then(() => store.dispatch(getUserData()));
  }

  const render = () => {
    (preloadedState ? ReactDom.hydrate : ReactDom.render)(
      <Provider store={store}>
        <App />
      </Provider>
      , document.getElementById("app")
    );
  };

  if (module.hot) {
    module.hot.accept("./components/App", () => {
      render();
    });
  }

  render();
}
